/* Ruby Rose — footer signup validation.
   Client-side only by design: there is no backend wired up yet, so submission
   is intercepted and reported inline. Swap `handleSubmit` for a real POST when
   a marketing endpoint exists. */

const PATTERNS = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  // UAE-friendly: optional +, country code, 7-15 digits, spaces/dashes allowed.
  tel: /^\+?[\d\s-]{7,18}$/,
};

class RubySignup extends HTMLElement {
  connectedCallback() {
    this.init();

    // Guard against upgrading before children are parsed (see ruby-carousel.js).
    if (!this.initialised) {
      document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
    }
  }

  init() {
    if (this.initialised) return;

    this.form = this.querySelector("form");
    this.input = this.querySelector("input");
    this.status = this.querySelector("[data-rr-status]");
    if (!this.form || !this.input) return;
    this.initialised = true;

    this.type = this.input.type === "tel" ? "tel" : "email";

    this.form.addEventListener("submit", (event) => this.handleSubmit(event));
    this.input.addEventListener("input", () => this.clear());
  }

  clear() {
    this.removeAttribute("data-rr-state");
    if (this.status) this.status.textContent = "";
    this.input.setAttribute("aria-invalid", "false");
  }

  handleSubmit(event) {
    event.preventDefault();

    const value = this.input.value.trim();

    if (!value) {
      return this.fail(this.dataset.messageEmpty || "Please enter a value.");
    }

    if (!PATTERNS[this.type].test(value)) {
      return this.fail(this.dataset.messageInvalid || "Please check the format.");
    }

    this.succeed(this.dataset.messageSuccess || "Thank you — you're on the list.");
  }

  fail(message) {
    this.setAttribute("data-rr-state", "error");
    this.input.setAttribute("aria-invalid", "true");
    if (this.status) this.status.textContent = message;
    this.input.focus();
  }

  succeed(message) {
    this.setAttribute("data-rr-state", "success");
    this.input.setAttribute("aria-invalid", "false");
    if (this.status) this.status.textContent = message;
    this.form.reset();
  }
}

if (!customElements.get("ruby-signup")) {
  customElements.define("ruby-signup", RubySignup);
}
